import * as preact from 'preact'
const { h, Component } = preact
import { testReducedMotion } from '@nrk/feature-tests'

import styles from './index.css'
import { Wall } from './wall'

interface Props {
  visible: boolean;
}

interface State {
  percent: number;
}
export class Kloster extends Component<Props, State> {
  constructor() {
    super()
    this.state = {
      percent: 0
    }
  }
  reducedMotion = testReducedMotion()
  wrapper = undefined

  componentDidMount() {
    if (this.props.visible) {
      requestAnimationFrame(this.update)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.update()
    }
  }

  update = () => {
    if (this.props.visible) {
      requestAnimationFrame(this.update)
      const { top, bottom, height } = this.wrapper.getBoundingClientRect()
      const scrollPositionFromDocumentTop = window.pageYOffset + window.innerHeight
      const imageBottomPositionFromDocumentTop = bottom + window.pageYOffset

      const s = window.innerHeight - height

      let offset
      if (s > 350) {
        offset = 0
      } else {
        offset = -(1 / 6) * s + 350
      }

      const imagePosAboveMin =
        scrollPositionFromDocumentTop + offset >= imageBottomPositionFromDocumentTop
      const imagePosBelowMax = top > -offset
      const animate = imagePosAboveMin && imagePosBelowMax

      if (animate) {
        const percent = (1 - (top + offset) / (window.innerHeight + offset * 2 - height)) * 100

        if (percent !== this.state.percent) {
          this.setState({ percent })
        }
      } else {
        if (top < 0 - offset) {
          this.setState({ percent: 100 })
        } else {
          this.setState({ percent: 0 })
        }
      }
    }
  }

  render() {
    if (!this.reducedMotion) {
      return (
        <div className={styles.parallax__wrapper}>
          <div className={styles['parallax-container']} ref={el => (this.wrapper = el)}>
            <img
              alt="Tegning av kloster med fengselsmur foran"
              className={styles.layer}
              srcset="
            https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/bg-400.jpg 400w,
            https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/bg-800.jpg 800w,
            https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/bg-1200.jpg 1200w"
              src="https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/full.jpg"
            />
            <Wall animate={this.state.percent > 26} />
          </div>
        </div>
      )
    }
    return (
      <div className={styles.parallax__wrapper}>
        <div className={styles['parallax-container']} ref={el => (this.wrapper = el)}>
          <img
            className={styles.bg}
            alt="Tegning av kloster med fengselsmur foran"
            src="https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/full.jpg"
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/Body/Kloster/index.tsx